(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zf-batch-lookup"] && !Shopify.designMode) return;
  try {
    (function () {
    // Returns { handle, label } or null. "1", "#1", "batch 1", "Batch-1", "No. 1", "001" -> batch-1 / Batch 1.
    function normalize(raw) {
      var t = String(raw || '').toLowerCase().trim();
      var n = t.replace(/(batch|number|num|no)\.?/g, ' ').replace(/[#:]/g, ' ').replace(/^[\s._\-\u2010-\u2015\u2212]+|[\s._\-\u2010-\u2015\u2212]+$/g, '');
      var m = n.match(/^0*(\d{1,9})$/);
      if (m && parseInt(m[1], 10) > 0) {
        var num = String(parseInt(m[1], 10));
        return { handle: 'batch-' + num, label: 'Batch ' + num };
      }
      // anything else (e.g. an old ZF-1004-1 number): try it as a plain handle
      var h = t.replace(/[\u2010-\u2015\u2212_.#\/\\\s]+/g, '-').replace(/[^a-z0-9-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '');
      return h ? { handle: h, label: h.toUpperCase() } : null;
    }
    function init(form) {
      if (form.dataset.zfReady) return;
      form.dataset.zfReady = '1';
      var input = form.querySelector('.zf-lookup__input');
      var msg = form.querySelector('.zf-lookup__msg');
      var btn = form.querySelector('.zf-lookup__button');
      function show(text, isError) {
        msg.textContent = text;
        msg.hidden = !text;
        msg.classList.toggle('zf-lookup__msg--error', !!isError);
      }
      var params = new URLSearchParams(window.location.search);
      if (params.get('batch_not_found')) {
        input.value = params.get('batch_not_found');
        show(form.dataset.notFound, true);
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var batch = normalize(input.value);
        if (!batch) { show('Enter your batch number, e.g. 12 or Batch 12.', true); input.focus(); return; }
        input.value = batch.label;
        var url = form.dataset.base + encodeURIComponent(batch.handle);
        btn.setAttribute('aria-busy', 'true');
        show('Looking up ' + batch.label + '…', false);
        fetch(url, { method: 'GET', credentials: 'same-origin', headers: { 'X-Requested-With': 'zf-lookup' } })
          .then(function (r) {
            if (r.ok) { window.location.href = url; return; }
            btn.removeAttribute('aria-busy');
            show(form.dataset.notFound, true);
            input.focus();
          })
          .catch(function () { window.location.href = url; });
      });
    }
    function boot() { document.querySelectorAll('[data-zf-lookup]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zf-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.zfQuickAddReady) return;
    window.zfQuickAddReady = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-zf-quick-add]');
      if (!btn) return;
      var msg = btn.parentElement.querySelector('.zf-card__msg');
      btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.zfQuickAdd), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          btn.removeAttribute('aria-busy');
          if (msg) msg.innerHTML = 'Added. <a href="/cart">View cart</a>';
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'zf-quick-add', data: { source: 'zf-quick-add', itemCount: cart.item_count } } }));
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          if (msg) msg.textContent = 'Could not add. Please try again.';
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
